import type { VisualizationScale, Vector3Data } from "../types/astronomy";
import { astronomicalToThree } from "../astronomy/coordinateSystems";
import {
  TRUE_SCALE,
  kmToSceneMeters,
  sceneMetersToKm,
  kmToSceneMm,
  KM_TO_SCENE_METERS,
  REAL_KM_PER_SCENE_MM,
} from "../astronomy/units";

export {
  TRUE_SCALE,
  kmToSceneMeters,
  sceneMetersToKm,
  kmToSceneMm,
  KM_TO_SCENE_METERS,
  REAL_KM_PER_SCENE_MM,
};

export function toScenePosition(
  positionKm: Vector3Data,
  scale: VisualizationScale,
): [number, number, number] {
  const mapped = astronomicalToThree(positionKm);
  const s = scale.distanceScale;
  return [mapped.x * s, mapped.y * s, mapped.z * s];
}

export function toSceneRadius(
  radiusKm: number,
  scale: VisualizationScale,
): number {
  return radiusKm * scale.radiusScale;
}

/** Escala de referência: 1000 km → 1 mm → 0,001 m. */
export function describeScale(): string {
  return "1000 km reais = 1 mm no modelo (escala proporcional)";
}
